import { create } from 'zustand'

// SSR-safe localStorage access: during the prerender/build render there is no
// `localStorage`, so reads default to false and writes are no-ops. Cookie
// consent is corrected on the client after hydration. Guarding here also
// prevents a hydration mismatch (server has no stored value, client may).
const hasStorage = typeof localStorage !== 'undefined'
const readConsent = () =>
  hasStorage && localStorage.getItem('cookie-consent') === 'true'
const writeConsent = (consent: boolean) => {
  if (hasStorage) localStorage.setItem('cookie-consent', String(consent))
}

interface UiState {
  isMobileMenuOpen: boolean
  isChatOpen: boolean
  isCartDrawerOpen: boolean
  cookieConsent: boolean
  setMobileMenu: (open: boolean) => void
  setChatOpen: (open: boolean) => void
  setCartDrawer: (open: boolean) => void
  setCookieConsent: (consent: boolean) => void
}

export const useUiStore = create<UiState>((set) => ({
  isMobileMenuOpen: false,
  isChatOpen: false,
  isCartDrawerOpen: false,
  cookieConsent: readConsent(),
  setMobileMenu: (open) => set({ isMobileMenuOpen: open }),
  setChatOpen: (open) => set({ isChatOpen: open }),
  setCartDrawer: (open) => set({ isCartDrawerOpen: open }),
  setCookieConsent: (consent) => {
    writeConsent(consent)
    set({ cookieConsent: consent })
  },
}))
